import { Grid } from '@mui/material'
import dayjs from 'dayjs'
import { FormField } from 'global/components/Form'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useStore } from 'store'

export const FormularioRelatorioAej = () => {
    const selectedCompetence = useStore(state => state.competencia)
    const { setValue } = useFormContext()

    useEffect(() => {
        const date = dayjs(selectedCompetence, 'YYYY-MM').set('date', 1)

        const firstDay = date.format('YYYY-MM-DD')
        const lastDay = date.endOf('month').format('YYYY-MM-DD')

        setValue('dataInicial', firstDay)
        setValue('dataFinal', lastDay)
    }, [selectedCompetence, setValue])

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <FormField
                    name="dataInicial"
                    label="Data Inicial"
                    type="date"
                />
            </Grid>
            <Grid item xs={6}>
                <FormField name="dataFinal" label="Data Final" type="date" />
            </Grid>
        </Grid>
    )
}
